var Label = require('./base');

module.exports = Label;


//////////////////
// WEBPACK FOOTER
// ./src/label/index.js
// module id = 265
// module chunks = 0